import { render, staticRenderFns } from "./LinkInput.vue?vue&type=template&id=0a5be76a&"
import script from "./LinkInput.vue?vue&type=script&lang=ts&"
export * from "./LinkInput.vue?vue&type=script&lang=ts&"
import style0 from "./LinkInput.vue?vue&type=style&index=0&id=0a5be76a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports